import { HighContrastSelector, IButtonStyles, IStackStyles, memoizeFunction } from '@fluentui/react';
import { IAppTheme } from 'common/theme/AppTheme';

export const getStyles = memoizeFunction((theme: IAppTheme) => {
  const { appColors, palette } = theme;

  const actionButton: IButtonStyles = {
    root: {
      color: appColors?.blueTint20ToBlue20,
    },
    rootHovered: {
      color: appColors?.blueTint40ToBlue10,
    },
    rootFocused: {
      color: appColors?.blueTint40ToBlue10,
      '::after': {
        borderColor: `${appColors?.blueTint40ToBlue10} !important`,
      },
    },
    rootPressed: {
      color: palette.themePrimary,
    },
    label: {
      textAlign: 'start',
    },
  };
  const actionsWrapper: IStackStyles = { root: { width: '100%' } };

  const dismissButton: IButtonStyles = {
    root: {
      height: 32,
      width: 32,
      backgroundColor: 'transparent',
      padding: '8px 12px',
      color: theme.palette.white,
      // rootFocused is not consistently applying focus styles when in a layer
      '&:focus': {
        border: `2px solid ${theme.palette.white} !important`,
        [HighContrastSelector]: {
          border: '2px solid Highlight !important',
          color: 'Highlight !important',
        },
      },
    },
    rootHovered: {
      backgroundColor: `${theme.appColors?.gray26ToGray94} !important`,
      color: theme.palette.white,
      [HighContrastSelector]: {
        backgroundColor: 'Highlight !important',
        color: 'HighlightText !important',
      },
    },
    rootPressed: {
      backgroundColor: `${theme.appColors?.gray14ToWhite} !important`,
      color: theme.palette.white,
      [HighContrastSelector]: {
        backgroundColor: 'Highlight !important',
        color: 'HighlightText !important',
      },
    },
  };

  const icon = {
    marginTop: 4,
  };

  const text = {
    root: {
      color: theme.palette.white,
      [HighContrastSelector]: {
        color: 'CanvasText',
      },
    },
  };
  const textWrapper: IStackStyles = {
    root: {
      color: theme.palette.white,
      [HighContrastSelector]: {
        color: 'CanvasText',
      },
      '@supports (-webkit-line-clamp: 4)': {
        display: '-webkit-box',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': '4',
        overflow: 'hidden',
      },
    },
  };

  return {
    actionButton,
    actionsWrapper,
    dismissButton,
    icon,
    text,
    textWrapper,
  };
});
